"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regist_1 = require("../../../redux/regist");
const server_1 = require("../../../server");
const classes_1 = require("../../../server/classes");
const action_1 = require("../../menu/action");
const constants_1 = require("../../menu/constants");
const account_1 = require("../account");
const classes_2 = require("../classes");
const actionTypes_1 = require("./actionTypes");
function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
            return cookieValue;
        }
    }
    return null;
}
const initRefreshToken = async (store) => {
    const refresh_token = getCookie('refresh_token');
    const classesId = (0, classes_2.getClassesId)();
    try {
        if (classesId || location.pathname.includes('admin-page')) {
            try {
                const classData = await (0, classes_1.getClassesList)({ id: classesId });
                const { total_count, items } = classData.result;
                if (total_count > 0 || location.pathname.includes('admin-page')) {
                    const classes_data = items.find(i => i.id === classesId);
                    store.dispatch((0, classes_2.setClassesData)(classes_data));
                    if (refresh_token) {
                        const response = await (0, server_1.postRefreshToken)({ refresh_token });
                        const access_token = response.result.access_token;
                        if (access_token) {
                            store.dispatch((0, account_1.setToken)({ access_token, refresh_token }));
                            const verifyResponse = await (0, server_1.postVerifyToken)({ access_token });
                            const user = verifyResponse.result.user;
                            if (user) {
                                if (location.pathname.includes('admin-page') &&
                                    user.role_name !== 'admin' &&
                                    user.role_name !== 'academy') {
                                    APP.eventManager.publish('updateMenu', 'accept');
                                    return;
                                }
                                if (user.role_name !== 'admin' && user.role_name !== 'academy') {
                                    const verifyClasses = await (0, classes_1.getClassesList)({
                                        id: classesId,
                                        belong_any: user.id,
                                    });
                                    if (verifyClasses.result.total_count < 1) {
                                        throw Error('해당 클래스에 접근할 수 없습니다.');
                                    }
                                    if (verifyClasses.result.items[0].status === 'inactive') {
                                        window.close;
                                        throw Error('해당 클래스에 접근할 수 없습니다.');
                                    }
                                }
                                else {
                                    if (classes_data &&
                                        user?.tenant_id !== 'default' &&
                                        user?.tenant_id !== classes_data.tenant_id) {
                                        throw Error('해당 클래스에 접근할 수 없습니다.');
                                    }
                                }
                                if (user) {
                                    const isAdminPage = location.pathname.includes('admin-page');
                                    const isAcademyRole = user.role_name === 'academy';
                                    const itemName = isAdminPage ? 'admin_menu' : 'test_menu';
                                    const savedMenus = localStorage.getItem(itemName);
                                    if (!savedMenus || isAcademyRole) {
                                        if (isAdminPage && isAcademyRole) {
                                            store.dispatch((0, action_1.updateMenu)('academyStatistics', { menu: 'academyStatistics', detail: 'list' }));
                                        }
                                        else {
                                            store.dispatch((0, action_1.updateMenu)(isAdminPage ? constants_1.DEFAULT_ADMIM_DEPTHS : constants_1.DEFAULT_DEPTHS, isAdminPage ? constants_1.DEFAULT_ADMIM_MENU : constants_1.DEFAULT_MENU));
                                        }
                                    }
                                    classes_data &&
                                        store.dispatch((0, account_1.setManager)(classes_data.managers));
                                    const isStudent = user.role_name === 'admin' || user.role_name === 'academy'
                                        ? false
                                        : classes_data.members.includes(user.id);
                                    store.dispatch((0, account_1.setUserInfo)(user, !isStudent));
                                }
                                else {
                                    throw Error('로그인 오류입니다. 다시 로그인하세요.');
                                }
                            }
                        }
                    }
                    else {
                        if (location.pathname.includes('admin-page')) {
                            APP.eventManager.publish('updateMenu', 'accept');
                            return;
                        }
                        throw Error('로그인 오류입니다. 다시 로그인하세요.');
                    }
                }
            }
            catch (error) {
                //alert('로그인 오류입니다. 다시 로그인하세요. ' + error);
                alert(error.message);
                console.error('Error in initRefreshToken:', error);
                window.close();
            }
        }
        else {
            window.close();
        }
    }
    catch (err) {
        console.error('Error in initRefreshToken:', err);
    }
};
const changeClassesData = async (store) => {
    const classesId = (0, classes_2.getClassesId)();
    try {
        if (classesId) {
            try {
                const classData = await (0, classes_1.getClassesList)({ id: classesId });
                const { total_count, items } = classData.result;
                if (total_count > 0) {
                    const classes_data = items.find(i => i.id === classesId);
                    store.dispatch((0, classes_2.setClassesData)(classes_data));
                }
            }
            catch (error) {
                //alert('로그인 오류입니다. 다시 로그인하세요. ' + error);
                alert(error.message);
                console.error('Error in initRefreshToken:', error);
                window?.close();
            }
        }
        else {
            window?.close();
        }
    }
    catch (err) {
        console.error('Error in initRefreshToken:', err);
    }
};
regist_1.MiddlewareRegistry.register(store => next => async (action) => {
    switch (action.type) {
        case actionTypes_1.APP_WILL_LOAD:
            if (location.pathname.includes('player')) {
                const access_token = localStorage.getItem('access_token');
                if (access_token) {
                    store.dispatch((0, account_1.setToken)({ access_token, refresh_token: null }));
                    const verifyResponse = await (0, server_1.postVerifyToken)({ access_token });
                    const user = verifyResponse.result.user;
                    if (user) {
                        const isStudent = user.role_name === 'admin';
                        store.dispatch((0, account_1.setUserInfo)(user, !isStudent));
                    }
                }
                return next(action);
            }
            try {
                await initRefreshToken(store);
                setInterval(async () => {
                    initRefreshToken(store);
                }, 24 * 60 * 60 * 1000); // Repeat every 15 minutes
            }
            catch (error) {
                console.error('Error fetching user info:', error);
                if (!location.pathname.includes('login')) {
                    alert('잘못된 사용자 정보입니다. 다시 로그인하세요' + error);
                }
                // 예외 발생 시 로직 처리
            }
            // if (location.pathname.includes('login')) return;
            // window.location.assign(`/login`);
            break;
        case actionTypes_1.SET_CHANGE_CLASSES:
            await changeClassesData(store);
            break;
    }
    return next(action);
});
